import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tabs',
  template: `
    <div class="row">
        <div class="tabs" *ngFor="let tab of Tabs; let i=index;"> 
            <div class="tab-button"  [ngClass]="{'active': i == idxActive}" *ngIf="tab.isShow" (click)="showTabContent(i)">
                <p [innerHTML]="tab.Title"></p>
            </div>
        </div>    
    </div>
  `,
  styles: [
     `.tab-button {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 0;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 0px;  
        border-color: #285c7e;
        color: #fff;
        font-weight: 500;
        background-color:#2f9bc6; 
        text-align: center;
        min-height: 62px;
        width: 117.5px;
        margin-bottom: 0px;
        margin-right: 1.5px;
        transition: box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        transition-delay: 0.2s;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26); 
      }
      .tab-button.active {
        background-color: #285c7e;
      }
      
      .tab-button > p {
        margin-bottom: 6px;
        padding-top: 4px;
      }

      @media only screen and (min-width: 768px) { 
        .tab-button {
          width: 150px;
        }
      }
    
      /* Small devices (landscape phones, less than 768px) */
      @media only screen and (max-width: 767px) {
        .tab-button {
          width: 117.5px;
        }
      }
      `
  ]
})

export class TabsComponent implements OnInit {
  @Input() Tabs = [{Title: "Tab1", isShow: true, Content: "tab1Content"}, {Title: "Tab2", isShow: true}, {Title: "Tab3", isShow: true}];
  @Output() activTabChanged = new EventEmitter();
  idxActive = 0;
  @Output() theLatestTab = new EventEmitter();
  
  ngOnInit(): void {
    this.showTabContent(0);
  }

  showTabContent (idx) {
    this.idxActive = idx;
    let i = 0;
    this.Tabs.forEach (tab => {
        if (tab.Content) {
            let tabcontent = document.getElementById(tab.Content)
            if (tabcontent)
              tabcontent.hidden = (i == this.idxActive) ? false : true;
        }
        i++;
    });
    this.activTabChanged.emit();
  }

  gotoNextTab() {
    let idx = this.idxActive + 1;
    while (idx < this.Tabs.length && !this.Tabs[idx].isShow)
      idx++;

    if (idx >= this.Tabs.length)
      this.theLatestTab.emit();
    else {
      this.showTabContent(idx);
      window.scroll(0,0);
    }    
  }
  
}
